import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  margin-left: -120px;
  z-index: 2;
`;
